import { hide } from './hide';
import { show } from './show';
import { register, unregister } from './register';
export default {
    hide,
    show,
    register,
    unregister,
};
